import { AuthLayout } from "js/components/auth/layouts/auth-layout";

export const AuthIndex = [
	{ path: "/auth", component: AuthLayout }
];
